import axios from 'axios'
import router from '@/router'

// //除正式以外  其他使用测试地址 
// if (location.hostname == '47.110.76.255') {
// 	//正式地址
// axios.defaults.baseURL = 'http://47.110.76.255:18083/ppManager/'
// }else {
// 	axios.defaults.baseURL = 'http://47.95.10.169:8080/ppManager/'
// }
  axios.defaults.baseURL = 'http://121.43.129.105/ppManager/' //正式版本
 //axios.defaults.baseURL = 'http://121.43.129.105:8083/ppManagertest/' //测试

// axios.defaults.baseURL = 'http://192.168.40.244:8081/ppManager/'
//设置token
axios.interceptors.request.use(
  config => {
      const token = localStorage.getItem('token')
      if (token) {
				config.headers.token = token;
      }
      return config
  },
  error => {
      return Promise.reject(error)
  }
)
// http response 错误拦截器
axios.interceptors.response.use(
	response => {
		if(response.data.errCode == 401) {
			router.replace({
					path: '/login/login'
			})
		}
		else
			return response;
	},
	error => {
		//alert('系统错误请联系管理员!');
})

export default axios


// WEBPACK FOOTER //
// ./src/lib/axios.js